<template>
  <div id="sample-advanced-filter-modal">
    <div v-if="!hideButton">
      <md-button
        class="pxd-1 m-0"
        @click="openModal"
      >
        <span>{{ btnText }}</span>
        <md-icon
          class="m-0 ml-1"
          :md-src="'/static/images/hand-truck.svg'"
        />
      </md-button>
    </div>
    <modal
      ref="refCollectionPointModal"
      template="filter"
      ref-name="refCollectionPointModal"
      close-button-enabled
      :title="title"
      second-button-sub-text="Selecionar"
      @second-cta="submitModal"
    >
      <FieldContainer label="Posto de coleta">
        <select-search
          id="txtCollectionPointName"
          ref="refSearchCollectionPoint"
          :value="collectionPoint"
          :options="collectionPointOptions"
          placeholder="Selecione um posto de coleta"
          :uppercase-all-items="true"
          :footer-enabled="false"
          :no-results-message-enabled="true"
          :icon-visible="false"
          no-results-text="Não foi encontrado posto de coleta cadastrado com esse nome"
          @change="onCollectionPointChange"
        />
      </FieldContainer>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FieldContainer from '../common/FieldContainer.vue'
import SelectSearch from '../common/SelectSearch.vue'

export default {
  name: 'CollectionPointModal',

  components: {
    FieldContainer,
    SelectSearch
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: 'Selecione o Posto de Coleta'
    },
    value: {
      type: [String, Object],
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    },
    hideButton: {
      type: Boolean,
      default: false
    }
  },

  emits: ['change'],

  data() {
    return {
      collectionPoint: ''
    }
  },

  computed: {
    ...mapGetters(['collectionPointLabels']),

    collectionPointOptions() {
      if (!this.collectionPointLabels || this.collectionPointLabels.length === 0) {
        return [];
      }
      
      const allOption = {
        label: "Todos",
        value: "Todos",
        id: "ALL"
      };
      
      return [allOption, ...this.collectionPointLabels];
    }
  },

  watch: {
    showModal(newValue) {
      if (newValue) {
        this.openModal()
      }
    }
  },

  methods: {
    ...mapActions(['getAllCollectionPointList']),

    openModal() {
      this.collectionPoint = this.value
      this.$nextTick(() => {
        this.$refs.refCollectionPointModal.open()
        this.$refs.refSearchCollectionPoint.field = this.collectionPoint
        this.getAllCollectionPointList()
      })
    },

    clearModal() {
      this.refSearchCollectionPoint.field = ''
      this.collectionPoint = ''
    },

    submitModal() {
      this.emitChange()
      this.$refs.refCollectionPointModal.close()
    },

    emitChange() {
      this.$emit('change', this.collectionPoint)
    },

    onCollectionPointChange(newVal) {
      this.collectionPoint = newVal
    }
  }
}
</script>
